export const getAssetUrl = (assetUrl) =>
  process.env.NODE_ENV === 'development'
    ? `http://localhost:1337${assetUrl}`
    : assetUrl
